import {
  Injectable,
} from '@angular/core';
import {
  Store,
} from '@ngrx/store';
import {
  FactsService,
  RulesEngineRunnerService,
} from '@o3r/rules-engine';
import {
  UiStatusStore,
} from '@refx/shared-store';
import {
  getFlowType,
  getLoadingContext,
} from './fact-factories/ui-status.fact';
import {
  UiStatusFacts,
} from './ui-status.facts';

@Injectable()
export class UiStatusFactsService extends FactsService<UiStatusFacts> {
  public facts = {
    loadingContext: this.store.pipe(getLoadingContext()),
    flowType: this.store.pipe(getFlowType())
  };

  constructor(rulesEngine: RulesEngineRunnerService, private readonly store: Store<UiStatusStore>) {
    super(rulesEngine);
  }
}
